module.exports = __webpack_public_path__ + "lato-light-webfont.77425570e1795ddfc657.ttf";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/fonts/lato-light-webfont.ttf
// module id = ../../../../../resources/fonts/lato-light-webfont.ttf
// module chunks = styles